import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Check, Globe } from "lucide-react";

const languages = [
  { code: "fa", label: "فارسی", flag: "🇮🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "ar", label: "العربية", flag: "🇸🇦" },
  { code: "tr", label: "Türkçe", flag: "🇹🇷" },
];

export default function FooterLanguageSelector() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  const currentLang = languages.find((l) => l.code === i18n.language) || languages[0];

  return (
      <DropdownMenu>
          <DropdownMenuTrigger asChild>
              <Button
                  variant="ghost"
                  size="sm"
                  className="flex items-center gap-2 text-gray-500 hover:text-[#0072CE] hover:bg-blue-50/50 transition-colors border border-zinc-200 hover:border-blue-100 rounded-full px-4"
              >
                  <Globe className="h-4 w-4" />
                  <span>{currentLang.label}</span>
              </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent side="top" align="center" className="w-[110px] bg-white/95 backdrop-blur-md border-blue-100 shadow-lg mb-2">
              {languages.map((lang) => (
                  <DropdownMenuItem
                      key={lang.code}
                      onClick={() => changeLanguage(lang.code)}
                      className={`flex items-center justify-between cursor-pointer my-1 ${i18n.language === lang.code ? "bg-blue-50 text-[#0072CE] font-medium" : "text-gray-600 hover:bg-gray-50"}`}
                  >
                      <span className="flex items-center gap-2">
                          <span className="text-lg">{lang.flag}</span>
                          {lang.label}
                      </span>
                  </DropdownMenuItem>
              ))}
          </DropdownMenuContent>
      </DropdownMenu>
  );
}